import React from 'react';
import ReactDOM from 'react-dom/client';
import './final.css';
import reportWebVitals from './reportWebVitals';
import App from './App'; // after rename to App.jsx

/*  ---------------------------------------------------------
    🔥 Fix: Prevent white screen if localStorage 'user' is corrupt
    --------------------------------------------------------- */
try {
  const raw = localStorage.getItem('user');
  if (raw) {
    const parsed = JSON.parse(raw);   // <-- this is where it used to crash
    if (!parsed || typeof parsed !== 'object') {
      localStorage.removeItem('user');
      console.warn('Corrupt user cleared from localStorage (auto-cleanup).');
    }
  }
} catch (e) {
  localStorage.removeItem('user');
  console.warn('Invalid user JSON removed from localStorage', e);
}
/* --------------------------------------------------------- */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
